export default {
  list: [
    {
      title: 'درصد',
      value: 'RSEE_PERCENT'
    },
    {
      title: 'مبلغ ثابت',
      value: 'RSEE_AMOUNT'
    }
  ],
  values: {
    RSEE_PERCENT: 'RSEE_PERCENT',
    RSEE_AMOUNT: 'RSEE_AMOUNT',
  }
};
